import { createAsyncThunk } from '@reduxjs/toolkit';

import { ProjectsService } from 'api';

import { PaginationParams } from 'models';

export const getPrimaryMarketItemsMore = createAsyncThunk(
	'primaryMarket/getPrimaryMarketItemsMore',
	async (params?: PaginationParams) => {
		return await ProjectsService.getAll(params);
	},
);
